<template>
  <div class="clue-pool" >
    <el-divider content-position="left">话术管理</el-divider>
    <el-row class="mb-10" style="padding-left: 0.1rem;">
      <el-col :span="2" class="m-label text_right">话术分类</el-col>
      <el-col :span="22">
        <el-radio-group
          @change="radioGroup"
          class="elRadioGroup"
          v-model="highSearch.talk_cate"
          size="small">
          <el-radio-button
            v-for="(item, index) in talkCate"
            :key="index"
            :label="item.cate_id">
            {{item.cate_name}}
          </el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="4" v-if="false">
        <el-select
          :filterable="true"
          v-model="highSearch.talk_cate"
          placeholder="请选择话术分类"
          size="mini" clearable>
          <el-option
            v-for="(item, index) in talkCate"
            :key="index"
            :label="item.cate_name"
            :value="item.cate_id" >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row style="padding-left: 0.1rem;margin-bottom: .4rem">
      <el-col :span="2" class="m-label text_right">话术标签</el-col>
      <el-col :span="22" style="padding-left: 0.1rem;padding-top: .1rem" >
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="highSearch.talk_tags" @change="handleCheckedCitiesChange">
          <el-checkbox style="margin-bottom: .1rem" v-for="item in talkTag" :label="item.tag_id" :key="item.tag_id">{{item.tag_name}}</el-checkbox>
        </el-checkbox-group>
      </el-col>
      <el-select
        v-if="false"
        :filterable="true"
        multiple
        collapse-tags
        v-model="highSearch.talk_tags"
        placeholder="请选择话术标签"
        size="mini" clearable>
        <el-option
          v-for="(item, index) in talkTag"
          :key="index"
          :label="item.tag_name"
          :value="item.tag_id">
        </el-option>
      </el-select>
    </el-row>
    <el-row>
      <el-col :span="24" class="tr">
        <el-button v-if="false" type="primary" size="mini" @click="handleSearch">查询</el-button>
        <el-button type="danger" size="mini" @click="handleCloseSearch">清除勾选</el-button>
      </el-col>
    </el-row>
    <el-row class="mb-10" style="padding-left: .1rem">
      <el-col :span="22"  class="search_position">
        <el-input prefix-icon="el-icon-search search"  v-model="search" size="mini" placeholder="输入话术标题或话术搜索" />
      </el-col>
      <el-col :span="2" class="tr"  v-if="pageNodes.indexOf('录入') !== -1">
        <el-button  type="primary" size="mini" @click="handleAddOpen">录入</el-button>
      </el-col>
    </el-row>
    <!--    border-->
    <el-table :data="pageData" size="medium" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column v-if="true" fixed label="ID" width="140"  prop="talk_id" ></el-table-column>
      <el-table-column class="el-status" width="140" fixed label="话术分类" prop="talk_cate_name" ></el-table-column>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="tableColumn(item.prop)">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row[item.prop]" placement="top">
            <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column  label="话术" prop="talk_answer">
        <template slot-scope="scope" >
          <el-tooltip :content="scope.row.talk_answer" placement="top">
            <span class="count_style" @click="copyUrl(scope.row.talk_answer)"  style="display: inherit; cursor: pointer">{{scope.row.talk_answer}} <i class="iconfont icon-fuzhi"></i></span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="60" v-if="pageNodes.indexOf('修改') !== -1">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改话术" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="handleEditOpen(scope.$index, scope.row)" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="tr mt-10"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 25, 50]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-drawer
      title="话术录入"
      :visible.sync="addDrawer"
      direction="rtl"
      :before-close="handleAddDrawerBeforeClose"
      size="40%">
      <div class="m-tabs-content">
        <div class="tabs_line">
          <div class="lines"></div>
          <h3 class="tabs-title">话术信息</h3>
        </div>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6"  class="m-label">话术标题：</el-col>
          <el-col :span="10" ><el-input  v-model="addForm.talk_title"  placeholder="请输入话术标题" :size="inputSize" clearable></el-input></el-col>
        </el-row>
        <el-row>
          <el-col :span="6"  class="m-label">话术分类：</el-col>
          <el-col :span="10">
            <el-select
              v-model="addForm.talk_cate"
              placeholder="请选择话术分类"
              :size="inputSize"
              clearable>
              <el-option
                v-for="item in talkCate"
                :key="item.cate_id"
                :label="item.cate_name"
                :value="item.cate_id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row >
          <el-col :span="6"  class="tr m-label text_right">话术标签:</el-col>
          <el-col :span="10">
            <el-select
              :filterable="true"
              multiple
              collapse-tags
              v-model="addForm.talk_tags"
              placeholder="请选择话术标签"
              size="mini" clearable>
              <el-option
                v-for="(item, index) in talkTag"
                :key="index"
                :label="item.tag_name"
                :value="item.tag_id" >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">话术参考：</el-col>
          <el-col :span="18">
            <el-input style="min-height: 1rem"  placeholder="请输入话术参考"  :autosize="textareaSize" type="textarea" v-model="addForm.talk_answer" size="mini" clearable ></el-input>
          </el-col>
        </el-row>
      </div>
      <el-row class="bottom-btn">
        <el-button @click="handleSave" size="mini" type="primary">保存</el-button>
      </el-row>
    </el-drawer>
    <el-drawer
      title="修改话术"
      :visible.sync="ContactDrawer"
      direction="rtl"
      :before-close="handleAddDrawerBeforeClose"
      size="40%">
      <el-tabs style="padding: 0 0.2rem 0 0.4rem" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="修改话术" name="first">
          <div class="m-tabs-content" style="padding: 0">
            <div class="tabs_line">
              <div class="lines"></div>
              <h3 class="tabs-title">基础信息</h3>
            </div>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="6"  class="m-label">话术标题：</el-col>
              <el-col :span="10" ><el-input @change="handelSaveChange('talk_title', '话术标题')"  v-model="saveForm.talk_title"  placeholder="请输入话术标题" :size="inputSize" clearable></el-input></el-col>
            </el-row>
            <el-row>
              <el-col :span="6"  class="m-label">话术分类：</el-col>
              <el-col :span="10">
                <el-select
                  @change="handelSaveChange('talk_cate', '话术分类')"
                  v-model="saveForm.talk_cate"
                  placeholder="请选择话术分类"
                  :size="inputSize"
                  clearable>
                  <el-option
                    v-for="item in talkCate"
                    :key="item.cate_id"
                    :label="item.cate_name"
                    :value="item.cate_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row ><!--                  talk_tags   talk_tag_names-->
              <el-col :span="6"  class="tr m-label text_right">话术标签:</el-col>
              <el-col :span="10">
                <el-select
                  @change="handelSaveChange('talk_tags', '话术标签')"
                  :filterable="true"
                  multiple
                  collapse-tags
                  v-model="saveForm.talk_tags"
                  placeholder="请选择话术标签"
                  size="mini" clearable>
                  <el-option
                    v-for="(item, index) in talkTag"
                    :key="index"
                    :label="item.tag_name"
                    :value="item.tag_id" >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">话术参考：</el-col>
              <el-col :span="18">
                <el-input style="min-height: 1rem" @change="handelSaveChange('talk_answer', '话术参考')"  placeholder="请输入话术参考"  :autosize="textareaSize" type="textarea" v-model="saveForm.talk_answer" size="mini" clearable ></el-input>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="话术历史" name="second">
          <div class="blocka">
            <el-timeline>
              <el-timeline-item  v-for="(item, index)  in OperationRecord" :key="index" :timestamp="item.created_at" placement="top">
                <el-card>
                  <p>{{item.operate}}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'Sales_Talk_Manage',
  props: {
    user: Object
  },
  data () {
    return {

      talkTagReturnCheckbox: [],
      checkAll: false,
      isIndeterminate: false,
      dialogVisible: false,
      uploadStatus: false,
      multipleSelection: [],
      count: '',
      uploadHeader: {Authorization: localStorage.token},
      search: '',
      searchData: {},
      inputSize: 'small',
      closeShow: false,
      highSearch: {
        talk_cate: '',
        talk_tags: []
      },
      optionProps: {
        value: 'id',
        label: 'Provincial',
        children: 'son'
      },
      textareaSize: { minRows: 6, maxRows: 10 },
      options: [],
      CluesPool: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },
      addDrawer: false,
      ContactDrawer: false,
      addForm: {
        talk_cate: '',
        talk_title: '',
        talk_answer: '',
        talk_tags: [],
        talk_cate_name: ''
      },
      saveForm: {
        index: null,
        id: null,
        talk_cate: '',
        talk_title: '',
        talk_answer: '',
        talk_tags: [],
        talk_tag_names: [],
        talk_cate_name: ''
      },
      col: [
        {
          label: '话术标签',
          prop: 'talk_tag_names',
          display: false
        },
        {
          label: '话术标题',
          prop: 'talk_title',
          display: false
        }
      ],
      activeName: 'first',
      loading: [],
      values: '',
      talkCate: [],
      talkCateReturn: [''],
      talkTag: [],
      talkTagReturn: [''],
      OperationRecord: [],
      pageNodes: [],
      status: false,
      talkTags: []
    }
  },
  computed: {
    pageData: function () {
      return this.CluesPool.filter(data => !this.search || data.talk_title.toLowerCase().includes(this.search.toLowerCase()) || data.talk_answer.toLowerCase().includes(this.search.toLowerCase())).slice(this.pageOption.pageSize * (this.pageOption.currentPage - 1), this.pageOption.pageSize * this.pageOption.currentPage)
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search ? this.searchTotal() : this.CluesPool.length
    }
  },
  methods: {
    radioGroup (val) {
      this.highSearch.talk_cate = val
      this.handelGetOrders(
        this.highSearch.talk_cate,
        this.highSearch.talk_tags
      )
    },
    handleCheckAllChange (val) {
      this.highSearch.talk_tags = val ? this.talkTagReturnCheckbox : []
      this.isIndeterminate = false
      this.handelGetOrders(
        this.highSearch.talk_cate,
        this.highSearch.talk_tags
      )
    },
    handleCheckedCitiesChange (value) {
      this.highSearch.talk_tags = value
      let checkedCount = value.length
      this.checkAll = checkedCount === this.talkTag.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.talkTag.length
      this.handelGetOrders(
        this.highSearch.talk_cate,
        this.highSearch.talk_tags
      )
    },
    copyUrl (data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '已成功复制到剪切板',
        type: 'success'
      })
      oInput.remove()
    },
    handelSaveChange (field, fieldName) {
      let index = this.saveForm.index
      this.SaveChangeMethods(index, field, fieldName)
    },
    SaveChangeMethods (index, field, fieldName) {
      for (var a = 0; a < this.pageData.length; a++) {
        if (this.saveForm.id === this.pageData[a].talk_id) {
          if (this.pageData[a][field] === this.saveForm[field]) {
            return
          }
        }
      }
      var old = ''
      if (this.pageData[index][field] instanceof Array) {
        old = this.pageData[index].talk_tag_names
        this.status = true
      } else {
        old = this.pageData[index][field]
      }
      // if (this.pageData[index][field] === this.saveForm[field]) return
      this.$axios.post('/api/trick/update/' + this.saveForm.id, {
        fieldName: field,
        value: this.saveForm[field],
        old: old,
        typeName: fieldName
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            if (this.status) {
              this.handleForMethods(this.saveForm.id, 'talk_tag_names', data.data)
            } else {
              this.handleForMethods(this.saveForm.id, field, data.data)
            }
            this.$message.success(data.msg)
            this.OperationRecord.unshift(data.data.operate_list)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleForMethods (id, field, data) {
      for (var a = 0; a < this.pageData.length; a++) {
        if (id === this.pageData[a].talk_id) {
          console.log(field)
          if (field === 'talk_cate') {
            this.pageData[a].talk_cate_name = data.talk_cate_name
            this.pageData[a].talk_cateId = data.talk_cate
          } else if (field === 'talk_tag_names') {
            this.pageData[a].talk_tag_names = data.talk_tag_names
            this.pageData[a].talk_tags = data.talk_tags
            this.status = false
          } else {
            this.pageData[a][field] = this.saveForm[field]
          }
          this.talkTags = []
        }
      }
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    getTalkCate () {
      this.$axios.get('/api/talkcate/list')
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.talkCate = data.data
            for (var a = 0; a < data.data.length; a++) {
              this.talkCateReturn.push(data.data[a].cate_name)
            }
          }
        })
      this.$axios.get('/api/talktag/list')
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.talkTag = data.data
            for (var a = 0; a < data.data.length; a++) {
              this.talkTagReturn.push(data.data[a].tag_name)
              this.talkTagReturnCheckbox.push(data.data[a].tag_id)
            }
          }
        })
    },
    tableColumn (prop) {
      let width = ''
      if (prop === 'talk_tag_names') {
        width = 180
      }
      return width
    },
    selectExport (val) {
      console.log(val)
    },
    selectType (val) {
      console.log(val)
    },
    handleExport () {
      this.$axios.post('/api/thread/excelout', {params: {start_time: this.startTime, end_time: this.endTime, input_types: this.value2}}, {responseType: 'blob'})
        .then((res) => {
          if (res.status === 205) {
            return
          }
          let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let objectUrl = window.URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.href = objectUrl
          link.download = '线索.xlsx'
          link.click()
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl)
          }, 100)
          // window.location.href = objectUrl
        })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    groupInput (val) {
      this.highSearch.group_chat_id = val
    },
    handleSearch () {
      this.handelGetOrders(
        this.highSearch.talk_cate,
        this.highSearch.talk_tags
      )
    },
    handleCloseSearch () {
      this.highSearch.talk_cate = ''
      this.highSearch.talk_tags = []
      this.isIndeterminate = false
      this.checkAll = false
      this.handelGetOrders(
        this.highSearch.talk_cate,
        this.highSearch.talk_tags
      )
    },
    handleChangeHeight (val) {},
    handelGetOrders (talkCate, talkTags) {
      this.$axios.post('/api/trick/list', {
        talk_cate: talkCate,
        talk_tags: talkTags
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.CluesPool = data.data.list
            this.pageNodes = data.data.pageNodes
            for (var i = 0; i < this.CluesPool.length; i++) {
              this.CluesPool[i].talk_cateId = this.CluesPool[i].talk_cate
              // this.CluesPool[i].talk_cate = this.talkCateMethods(this.CluesPool[i].talk_cate)
            }
            this.count = data.data.count
            this.pageOption.total = data.data.count
          }
        })
    },
    provinceCityData () {
      this.$axios.get('/api/thread/cities')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            for (var a = 0; a < data.data.length; a++) {
              this.options.push(data.data[a])
            }
          }
        })
    },
    talkCateMethods (key) {
      let vipData = this.talkCateReturn
      return vipData[key]
    },
    talkTagMethods (key) {
      let vipData = this.talkTagReturn
      return vipData[key]
    },
    searchTotal () {
      return this.CluesPool.filter(data => !this.search || data.talk_title.toLowerCase().includes(this.search.toLowerCase()) || data.talk_answer.toLowerCase().includes(this.search.toLowerCase())).length
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
    },
    handelSetValue () {
      for (var i = 0; i <= this.col.length; i++) {
        this.value1.push(i)
      }
    },
    handleAddOpen () {
      let that = this
      that.addDrawer = true
      // that.addForm.custom_city_name = that.custom_city_name
      // that.addForm.custom_province = that.value[0]
      // that.addForm.custom_city = that.value[1]
      // that.addForm.refer_cate = 1
    },
    handleAddDrawerBeforeClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearAddData()
          done()
        })
        .catch(_ => {})
    },
    handleAddDrawerClose () {
      this.addDrawer = false
      this.clearAddData()
    },
    clearAddData () {
      this.addForm.talk_title = ''
      this.addForm.talk_cate = ''
      this.addForm.talk_tags = ''
      this.addForm.talk_answer = ''
      this.talkTags = []
      this.OperationRecord = []
    },
    clearUpdateData () {
      this.ContactDrawer = false
      this.saveForm.talk_title = ''
      this.saveForm.talk_cate = ''
      this.saveForm.talk_tags = ''
      this.saveForm.talk_answer = ''
    },
    handleSave () {
      if (!this.addForm.talk_title) {
        this.$message.error('请输入话术标题')
        return
      }
      if (!this.addForm.talk_cate) {
        this.$message.error('请选择话术分类')
        return
      }
      if (!this.addForm.talk_tags) {
        this.$message.error('请选择话术标签')
        return
      }
      if (!this.addForm.talk_answer) {
        this.$message.error('请输入话术参考')
        return
      }
      let that = this
      this.$axios.post('/api/trick/create', that.addForm)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            data.data.talk_cateId = data.data.talk_cate
            // data.data.talk_cate = that.talkCateMethods(data.data.talk_cate)
            that.CluesPool.unshift(data.data)
            that.pageOption.total = that.CluesPool.length
            that.handleAddDrawerClose()
            that.$message.success(data.msg)
          } else {
            that.$message.error(data.msg)
          }
        })
    },
    handleEditOpen (index, row) {
      this.row = row
      this.ContactDrawer = true
      this.saveForm.index = index
      this.saveForm.id = row.talk_id
      for (var a = 0; a < row.talk_tags.length; a++) {
        this.talkTags.push(row.talk_tags[a].tag_id)
      }
      this.saveForm.talk_cate = row.talk_cateId
      this.saveForm.talk_cate_name = row.talk_cate_name
      this.saveForm.talk_tags = this.talkTags
      // this.saveForm.talk_tag_names = row.talk_tag_names
      this.saveForm.talk_title = row.talk_title
      this.saveForm.talk_answer = row.talk_answer
      this.getOperationRecord(row.talk_id)
    },
    getOperationRecord (id) {
      this.$axios.get('/api/trick/operate_list/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            for (var a = 0; a < data.data.length; a++) {
              this.OperationRecord.push(data.data[a])
            }
          }
        })
    },
    prePage () {
      if (this.pageOption.currentPage === 1) return
      this.pageOption.currentPage = this.pageOption.currentPage - 1
    },
    handleUpdateClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearUpdateData()
          done()
        })
        .catch(_ => {})
    },
    beforeAvatarUpload () {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }
  },
  mounted () {
    // this.provinceCityData()
    this.getTalkCate()
    this.handelGetOrders()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-date-editor
    width: 100% !important
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span
    color: #4c87fc
    font-size 0.36rem
    font-weight 400
  .clue-pool
    marginLeft()
    .count_style
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .icon-qingtonghuiyuan
      color: #E9935D;
    .icon-baiyinhuiyuan
      color: #E6E8FA
    .icon-huangjinhuiyuan
      color: #FFD32F;
    .icon-qingtong
      color: #40BBEC
    .icon-zuanshi
      color: #83A4FF;
    .icon-wangzhe
      color: #A8A8A8
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
  .mb-10
    margin-bottom: .2rem
    margin-top .6rem
    .search_position .el-input
      width 35%
  .mt-10
    margin-top: .2rem
  .count
    padding-left: .2rem
    line-height: .56rem
  .tr
    text-align: right
  .m-label
    line-height: .56rem
  .text_right
    text-align left
  .el-row
    margin-bottom: .6rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
  .el-select
    width: 100%
  .changeHeight
    padding 0
    margin-top .4rem
  .clue-pool >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .bottom-btn
    padding: .2rem
    text-align: right
  .el-position
    position relative
  .dot
    display inline-block
    width 0.1rem
    height 0.1rem
    border-radius 50%
    margin-right 0.1rem
    position absolute
    top 0
    left -.2rem
    bottom 0
    margin auto
  .el-collapse
    border-bottom 0
    border-top 0
  .el-collapse >>> .el-collapse-item__header
    color: #4C87FC
    font-weight bold
  .el-collapse >>> .el-collapse-item__arrow
    color: #4C87FC
  .el-collapse >>> .el-collapse-item__content
    padding-bottom 0
  .el_dialogs >>> .el-dialog__body
    padding-left 0
    padding-right 0
  .el_dialogs >>> .el-dialog__header
    padding 0
  .box_title
    margin-bottom .4rem
    padding-left .6rem
    span
      font-size 0.32rem
      color: #333
      font-weight bold
  .dialog_box
    padding-left 1.45rem
    padding-right 1.45rem
    .box_p
      font-size .28rem
      line-height .7rem
      color: #666666
    img
      width 100%
      margin-top .4rem
  .contents
    margin-bottom .4rem
    .dialog-footer
      display block
      position: absolute;
      right .4rem
      bottom .2rem
  .export_clues
    margin-bottom .4rem
  .hint
    margin-bottom  .4rem
    font-weight bold
  .show_phone
    flex-direction column
    overflow-y auto
    max-height 4rem
    .existPhone
      flex-direction row
      justify-content space-between
      box-sizing border-box
      width 100%
      padding-right .1rem
  .phone_span
    width 50%
    display inline-block
    margin-bottom 0.3rem
  .phone_span:nth-child(2n)
    text-align right
  /*滚动条整体样式*/
  ::-webkit-scrollbar{
    width: .1rem;/*竖向滚动条的宽度*/
    height: 10px;/*横向滚动条的高度*/
  }
  ::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
    background: #cdcdcd;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-track{/*滚动条轨道的样式*/
    background: #f8f8f8;
    border-radius: 5px;
  }
  .elRadioGroup >>> .el-radio-button .el-radio-button__inner
    border 1px solid #dcdfe6
    border-radius .08rem
    margin 0 .1rem .1rem
    box-sizing border-box
  .elRadioGroup >>> .el-radio-button__orig-radio:checked+.el-radio-button__inner
    box-shadow 0 0 transparent
</style>



// WEBPACK FOOTER //
// src/pages/Sales_Talk_Manage/Sales_Talk_Manage.vue